<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
//import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Change Password",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Change Password",
            items: [],
            user_info: [],
            name: '',
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },
        get_user_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'user/'+this.$route.params.uid)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.user_info = response.data;
                    this.name = this.user_info.name;
                    console.log(this.user_info);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        change_password(e)
        {
            if(this.confirm_password == this.new_password){
                this.ButtonSeen=true;
                e.preventDefault()
                
                const posting_ = {                
                    old_password: this.old_password,
                    new_password: this.new_password,
                    confirm_password: this.confirm_password,
                    user_id: this.$route.params.uid,
                };

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'user/change_password', posting_)
                .then(response => {
                    if (response) {
                      this.ButtonSeen=false; 
                      alert(response.data.message);                       
                    }
                    else{
                        this.ButtonSeen=false;
                        console.log('tak ok');
                    }
                });
            }
            else{
                e.preventDefault()
                alert('Password does not match!')
            }
        },

        //raw data----------------------------------------------------------
        

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader, 
    },

    mounted() {     
        this.get_user_by_id();      
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <h4><span class="badge badge-soft-primary badge-border">User Name : {{ name }}</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
              <form @submit="change_password">
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="old_password" class="form-label">Old Password*</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='old_password' type="password" class="form-control" id="old_password"  required />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="new_password" class="form-label">New Password*</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='new_password' type="password" class="form-control" id="new_password" required />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="confirm_password" class="form-label">Confirm Password*</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='confirm_password' type="password" class="form-control" id="confirm_password" required />
                  </div>
                </div>
                
                <hr class="my-4 text-muted">
                <div class="text-end col-lg-12">
                  <button type="submit" class="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>        
      </div>
    </div>
  </Layout>
</template>
